import React from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    HStack,
    Button,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    PlpGridDefaultIcon,
    PlpGridDefaultSelectedIcon,
    PlpGridAlternativeIcon,
    PlpGridAlternativeSelectedIcon
} from '../../../components/icons'

export const GRID_VIEW = {
    DEFAULT: 'default',
    ALTERNATIVE: 'alternative'
}

const GridViewSelector = ({gridView, setGridView}) => {
    const styles = useMultiStyleConfig('GridViewSelector')

    return (
        <Flex sx={styles.container} data-testid="grid-view-selector">
            <HStack sx={styles.stack}>
                <Button
                    variant="unstyled"
                    sx={styles.button}
                    width="24px"
                    borderBottom={
                        gridView === GRID_VIEW.DEFAULT ? '1px solid' : '1px solid transparent'
                    }
                    borderColor={
                        gridView === GRID_VIEW.DEFAULT ? 'webTypo.textPrimary' : 'transparent'
                    }
                    onClick={() => setGridView(GRID_VIEW.DEFAULT)}
                    data-testid="grid-view-default-btn"
                >
                    {gridView === GRID_VIEW.DEFAULT ? (
                        <PlpGridDefaultSelectedIcon boxSize="16px" color="webTypo.textPrimary" />
                    ) : (
                        <PlpGridDefaultIcon boxSize="16px" color="webTypo.textPrimary" />
                    )}
                </Button>
                <Button
                    variant="unstyled"
                    sx={styles.button}
                    borderBottom={
                        gridView === GRID_VIEW.ALTERNATIVE ? '1px solid' : '1px solid transparent'
                    }
                    borderColor={
                        gridView === GRID_VIEW.ALTERNATIVE ? 'webTypo.textPrimary' : 'transparent'
                    }
                    onClick={() => setGridView(GRID_VIEW.ALTERNATIVE)}
                    data-testid="grid-view-alternative-btn"
                >
                    {gridView === GRID_VIEW.ALTERNATIVE ? (
                        <PlpGridAlternativeSelectedIcon boxSize="24px" color="webTypo.textPrimary" />
                    ) : (
                        <PlpGridAlternativeIcon boxSize="24px" color="webTypo.textPrimary" />
                    )}
                </Button>
            </HStack>
        </Flex>
    )
}

GridViewSelector.propTypes = {
    gridView: PropTypes.string.isRequired,
    setGridView: PropTypes.func.isRequired
}

export default GridViewSelector
